import { ID, IDPrefixes, PrefixedID } from '@griply/types';

import { createCompositeId } from './encoded-ids/composite-id';

export const createPrefixId = (id: ID, prefix: IDPrefixes) =>
  createCompositeId(prefix, [id]);

export type PrefixIdRange = { start: string; end: string };

// Half-open id range for a Firestore documentId() query over one owner kind: [`goal:`, `goal;`).
export const getPrefixIdRange = (prefix: IDPrefixes): PrefixIdRange => {
  const start = createPrefixId('', prefix);
  const end =
    start.slice(0, -1) +
    String.fromCharCode(start.charCodeAt(start.length - 1) + 1);
  return { start, end };
};

export const getPrefixedId = (id: PrefixedID) =>
  id.substring(id.indexOf(':') + 1);

export const getPrefixedIdPrefix = (id: PrefixedID): IDPrefixes | undefined => {
  if (!isValidPrefixedId(id)) {
    return undefined;
  }

  return id.substring(0, id.indexOf(':')) as IDPrefixes;
};

export const isValidPrefixedId = (id: ID | PrefixedID): id is PrefixedID => {
  const colonIndex = id.indexOf(':');
  if (colonIndex === -1) {
    return false;
  }

  const prefix = id.substring(0, colonIndex);
  const baseId = id.substring(colonIndex + 1);

  return !!baseId && Object.values(IDPrefixes).includes(prefix as IDPrefixes);
};
